import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { ApiService } from 'src/app/shared/services/api.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { environment } from 'src/environments/environment';
import { ToastService } from 'src/app/shared/services/toast.service';
import { Table } from 'primeng/table';
import { Router } from '@angular/router';
import { UserService } from 'src/app/shared/services/user.service';

interface Column {
  field: string;
  header: string;
  sortable?: boolean;
}

@Component({
  selector: 'app-execute-query',
  templateUrl: './execute-query.component.html',
  styleUrls: ['./execute-query.component.scss']
})
export class ExecuteQueryComponent implements OnInit {
  @ViewChild('dtQuery') dtQuery!: Table;
  queryResults: any[] = [];
  sqlQuery: string = '';
  queryColumns: Column[] = [];
  loading: boolean = false;
  globalFilterFields: string[] = [];
  private readonly restrictedEmails = [
    'sahani.amit@gmail.com',
    'a.sahani@qnbn.qa',
    'mali@newtecx.com',
    'majd_hani_59@hotmail.com'
  ];

  constructor(
    private _http: HttpClient,
    private _loaderService: LoaderService,
    private _toastService: ToastService,
    private _router: Router,
    private _userService: UserService
  ) {}

  ngOnInit(): void {
    this.checkAccess();
  }

  private checkAccess(): void {
    const userEmail = this._userService.user?.EmailAddress;
    console.log(userEmail);


    if (!userEmail || !this.restrictedEmails.includes(userEmail)) {
      this._router.navigate(['/home']);
    }
  }

  private createApiService(): ApiService {
    const apiService = new ApiService(this._http);
    apiService['_baseUrl'] = environment.API_URL;
    return apiService;
  }

  private formatHeader(key: string): string {
    // Convert camelCase to Title Case with spaces
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, str => str.toUpperCase())
      .trim();
  }

  onGlobalFilter(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.dtQuery.filterGlobal(value, 'contains');
  }

  async executeSqlQuery(): Promise<void> {
    if (!this.sqlQuery.trim()) {
      this._toastService.warning('Please enter a SQL query', 'Warning');
      return;
    }

    this._loaderService.showLoader();
    const apiService = this.createApiService();
    
    try {
      const req$ = apiService.post(
        AppConstants.CONTROLLERS.VENDOR,
        'ExecuteSqlQuery',
        true,
        environment.APIs_PREFIX,
        { query: this.sqlQuery }
      );

      const response: any = await lastValueFrom(req$);
      
      if (response?.isSuccess) {
        this.queryResults = response.data || [];
        
        // Dynamically create columns based on the first result's properties
        if (this.queryResults.length > 0) {
          const firstResult = this.queryResults[0];
          this.queryColumns = Object.keys(firstResult).map(key => ({
            field: key,
            header: this.formatHeader(key),
            sortable: true
          }));
          this.globalFilterFields = this.queryColumns.map(col => col.field);
        } else {
          this.queryColumns = [];
          this.globalFilterFields = [];
        }
        
        this._toastService.success('Query executed successfully!', 'Success');
      } else {
        this._toastService.error(response?.data?.errorMessageEn || 'Failed to execute query.', 'Error');
      }
    } catch (error) {
      console.error('Failed to execute SQL query:', error);
      this._toastService.error('Failed to execute query due to an unexpected error.', 'Error');
    } finally {
      this._loaderService.hideLoader();
    }
  }
} 